import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import Alert from "@mui/material/Alert";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useNavigate } from "react-router-dom";
import { useCompetitorLinkRemovalStart } from "./useCompetitorLinkRemovalStart";
import { IfPermission } from "../../auth/IfPermission";

export function CompetitorLinkRemovalStart() {
  const navigate = useNavigate();
  const {
    competitorUrlsText,
    autoRemove,
    submitState,
    setCompetitorUrlsText,
    setAutoRemove,
    submit,
  } = useCompetitorLinkRemovalStart();

  const isSubmitting = submitState.kind === "submitting";
  const fieldError =
    submitState.kind === "error" ? submitState.fieldErrors.competitorUrls : undefined;
  const generalError = submitState.kind === "error" ? submitState.message : null;

  return (
    <IfPermission permission="competitor-link-removals.create">
      <Box p={3} maxWidth={720}>
        <Box mb={2}>
          <Button startIcon={<ArrowBackIcon />} onClick={() => {
      void navigate("/competitor-link-removals");
    }}>
            К списку прогонов
          </Button>
        </Box>

        <Typography variant="h4" mb={2}>Запустить очистку</Typography>

        {generalError !== null && (
          <Alert severity="error" sx={{ mb: 2 }}>{generalError}</Alert>
        )}

        <TextField
          label="URL конкурентов"
          placeholder="Один URL в строке, например:&#10;https://competitor-one.com&#10;https://competitor-two.com"
          value={competitorUrlsText}
          onChange={(event) => setCompetitorUrlsText(event.target.value)}
          multiline
          minRows={8}
          fullWidth
          error={fieldError !== undefined}
          helperText={fieldError ?? "Введите ссылки конкурентов — по одной в строке."}
          disabled={isSubmitting}
        />

        <Box mt={2}>
          <FormControlLabel
            control={
              <Checkbox
                checked={autoRemove}
                onChange={(event) => setAutoRemove(event.target.checked)}
                disabled={isSubmitting}
              />
            }
            label="Автоудаление (удалять найденные ссылки без подтверждения)"
          />
        </Box>

        <Box mt={3}>
          <Button variant="contained" onClick={submit} disabled={isSubmitting}>
            Запустить
          </Button>
        </Box>
      </Box>
    </IfPermission>
  );
}
